module.exports = __webpack_public_path__ + "static/media/Introduksjon-sprakforstaelse.bd8736b1.mp3";